import { forwardRef } from "react";

import { Icons } from "widgets";

import { type Variant } from "../../../../graphql.js";
import { Tile, type TileProps } from "../../../../modules/core/components/Tile.js";
import { ENTITY_TYPE } from "../../../../settings/settings.js";

interface VariantTileProps extends Pick<TileProps, "footNote"> {
  variant: Variant;
}

const VariantTile = forwardRef<HTMLDivElement, VariantTileProps>(function GeneTile(props, ref) {
  if (!props.variant) return null;

  return (
    <Tile
      title={props.variant.name}
      type={"Variant"}
      to={`/${ENTITY_TYPE.VARIANT}/${props.variant.id}`}
      icon={<img src={Icons.Tiles.Entity} width={24} height={30} />}
      footNote={props.footNote}
      ref={ref}
    >
      {props.variant.description}
    </Tile>
  );
});

export { VariantTile };
